import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_loader = _resolveComponent("resource-loader")!

  return (_openBlock(), _createBlock(_component_resource_loader, {
    task: _ctx.task,
    resource: _ctx.modelValue
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Report not found. ")
    ]),
    _: 1
  }, 8, ["task", "resource"]))
}